import { NavigateFunction } from "react-router-dom"
import cn from "classnames"
import { useCallback } from "react"
import { differenceInMinutes, parseISO } from "date-fns"

import { Button, Text } from "ui-kit/components-branded/index"
import { Icon } from "components"
import { Analytics } from "utils/analytics"
import { createClientCallPath } from "modules/Call/routing"
import { numberToMinutesInRussianGenitive } from "utils/infrastructure/wording-utils"

export function CallBanner({
    bookingHash,
    sessionStartDatetime,
    navigate,
}: {
    bookingHash: string
    sessionStartDatetime: string
    navigate: NavigateFunction
}) {
    const minutesBeforeStart = differenceInMinutes(parseISO(sessionStartDatetime), new Date())

    const goToCall = useCallback(() => {
        if (minutesBeforeStart > 0) {
            Analytics.before_session_not_started_connect()
        } else {
            Analytics.before_sessions_started_connect()
        }

        navigate(createClientCallPath(`/lobby/${bookingHash}`))
    }, [bookingHash, minutesBeforeStart, navigate])

    return (
        <div
            className={cn(
                "is-flex call-notification",
                minutesBeforeStart > 0
                    ? "call-notification__upcoming"
                    : "call-notification__current"
            )}
        >
            <Icon
                type="play-circle-outline"
                className="call-notification__icon mr-2"
                size={48}
                fill="white"
            />
            <Text isAccent className="is-flex-grow-1 is-flex is-align-items-center">
                {minutesBeforeStart > 0 ? (
                    <>
                        До начала сессии меньше {minutesBeforeStart}{" "}
                        {numberToMinutesInRussianGenitive(minutesBeforeStart)}
                    </>
                ) : (
                    <>Ваша сессия уже началась</>
                )}
            </Text>
            <div className="pl-2">
                <Button className="is-borderless" onClick={goToCall}>
                    Начать звонок
                </Button>
            </div>
        </div>
    )
}
